'use strict'
# TODO: Refactor filename/url assignment for live preview
define ['./uploadCompanyLogo.scss'], () ->
  (RentappService, $state, $filter, Upload, Landlord, RENTAPPLICATION_API_URL) ->
    restrict: "E"
    template: require("./uploadCompanyLogo.jade") 
    scope: {filename: "="}
    link: (scope, element, attrs) ->
      # Need to set host separately as ng-src somehow replaces it.

      scope.set_host = () ->
        if scope.filename
          scope.host = scope.filename.split("landlord-avatars")[0] + "landlord-avatars"

      scope.set_host()

      re =  /\/(([^\/\/]*)\.([^\?\/]*))(\?[^\/]+)?$/;
      scope.$watch 'filename', (newValue, oldValue) ->
        m = re.exec(newValue)
        if m
          scope.filename = m[0]

      scope.removeLogo = () ->
        Landlord.update(
          id: 'me',
          logo: null).$promise.then ->
            scope.filename =  null

      scope.upload = (file) ->
        scope.uploading = true

        Upload.upload
          url: "#{RENTAPPLICATION_API_URL}/api/v1/landlord/upload/"
          file: file
        .then((resp) ->
          scope.filename = resp.data.file_url
          scope.set_host()
        , (err) ->
          console.log(err)
        , (evt) ->
          scope.progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
        )
        .then ->
          scope.uploading = false
        
        



// WEBPACK FOOTER //
// ./directives/uploadCompanyLogo/uploadCompanyLogo.coffee